module.exports = __webpack_public_path__ + "images/category_lp/smartphone/store_images/3_a98a44ad62b5a8138ae049e122a5f86a.png";